import React, { useState } from 'react'
import ReactDom from 'react-dom'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'
import OurTheme from '../components/OurTheme';
import MapForm from '../components/MapForm';
import '../less/editMap.less'

import { getNewMapData, getNewMarker } from '../lib/helper'


function EditMap(props) {
    // in case there is existing mapData to show (i.e: When user input is failed to validate)
    let existingMapData = get(window, 'webbymaps.data.mapData')
    if (!isEmpty(existingMapData) && isEmpty(get(existingMapData, 'config.markers'))) {
        const newMarker = getNewMarker();
        existingMapData.config.markers = [newMarker]
    }
    const newMapData = getNewMapData()
    const errorNotifications = get(window, 'webbymaps.data.errorNotifications')
    const [mapData, setMapData] = useState(existingMapData ? existingMapData : newMapData)
    const previousMapName = get(existingMapData, 'name')

    return (
        <div id="add-map">
            <h2 id="title">Edit {previousMapName ? `"${previousMapName}"` : 'Map'}</h2>
            <MapForm mapData={mapData} setMapData={setMapData} errorNotifications={errorNotifications} {...props} />
        </div>
    )
}

ReactDom.render(<EditMap />, document.getElementById('root'))